<template>
	<van-tabbar v-if="show" v-model="active" active-color="#07ecfe" inactive-color="#979799" z-index="300">
		<van-tabbar-item v-for="(item) in tabs" :key="item.name" :to="item.path">
			<span>{{ $t(item.label) }}</span>
			<template #icon="props">
				<img :src="props.active ? item.iconActive : item.icon" :alt="$t(item.label)"
					:style="{ height: '19px' }" />
			</template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
export default {
	data() {
		return {
			active: 0,
			show: false,
			tabs: [{
				path: '/mobile/home',
				label: this.$t('首页'),
				icon: require('@/assets/img/footer/icon1.png'),
				iconActive: require('@/assets/img/footer/icon01.png')
			},
			{
				path: '/mobile/quotes',
				label: this.$t('行情'),
				icon: require('@/assets/img/footer/icon2.png'),
				iconActive: require('@/assets/img/footer/icon02.png')
			},
			{
				path: '/mobile/trade',
				label: this.$t('交易'),
				icon: require('@/assets/img/footer/icon3.png'),
				iconActive: require('@/assets/img/footer/icon03.png')
			},
			{
				path: '/mobile/service',
				label: this.$t('理财'),
				icon: require('@/assets/img/footer/icon4.png'),
				iconActive: require('@/assets/img/footer/icon04.png')
			},
			{
				path: '/mobile/mine',
				label: this.$t('资产'),
				icon: require('@/assets/img/footer/icon5.png'),
				iconActive: require('@/assets/img/footer/icon05.png')
			}
			]
		};
	},
	watch: {
		$route(to) {
			this.updateTabbar(to.path);
			console.log(to.path, 'to.name');
		}
	},
	created() {
		this.updateTabbar(this.$route.path);
		console.log(this.$route.path, 'to.name');

	},
	methods: {
		updateTabbar(routeName) {
			console.log(routeName, '4545');
			const index = this.tabs.findIndex(tab => tab.path === routeName);
			console.log(index);
			this.active = index;
			this.show = index !== -1;
			console.log(this.show);

		}
	},
};
</script>

<style lang="less" scoped>
.van-tabbar {
	height: 60px;
	background-color: #1a1b23;
}

.van-tabbar-item--active {
	background-color: #1a1b23;
}

.van-tabbar-item {
	font-size: 15px;
}

[class*="van-hairline"]::after {
	border: none !important;
}

.van-tabbar-item__icon img {
	margin-bottom: 2px;
}
</style>